<template>
  <div>
    <div
      v-for="(type, i) in types"
      :key="i"
    >
      <div
        v-if="type === 'loader'"
        class="lds-ellipsis"
      >
        <div />
        <div />
        <div />
        <div />
      </div>
      <div
        v-else
        class="skeleton"
        :class="typeToClass(type)"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    types: {
      type: Array,
      required: false,
      default: () => ['input'],
    },
  },
  methods: {
    typeToClass(type) {
      const [baseType, ...rest] = type.split(' ');
      const baseClass = `skeleton__${baseType}`;
      const extraClasses = rest.join(' ');
      return `${baseClass} ${extraClasses}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.skeleton {
  height: 20px;
  width: 100%;
  background-color: #eee;
  border-radius: 20px;
  margin-bottom: 8px;
}
.skeleton__h1 {
  height: 36px;
  width: 70%;
  margin-top: 24px;
}

.skeleton__input {
  height: 26px;
}

.skeleton__div {
  border-radius: 4px;
}
.wp100 {
  width: 100%;
}
.h100 {
  height: 100px;
}
.h150 {
  height: 150px;
}
.h200 {
  height: 200px;
}
.h300 {
  height: 300px;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
}
.lds-ellipsis div {
  position: absolute;
  top: 3px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #efefef;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
